<template>
  <div>
    <!-- 关联标签 -->
    <el-form-item label="关联店员">
      <el-input v-if="form.model.clerk.real_name" v-model="form.model.clerk.real_name" class="max-w460"></el-input>
      <el-button type="primary"  @click="changeProduct()">选择店员</el-button>
      <el-button   @click="deleteClick()">清除店员</el-button>
    </el-form-item>
    <!--标签选择-->
    <Clerk :isproduct="isproduct" @closeDialog="closeDialogFunc"></Clerk>

  </div>
</template>

<script>
import Clerk from '@/components/supply/Clerk';

export default {
  components: {
    /*选择商品组件*/
    Clerk,
  },
  data() {
    return {
      unit: '%',
      isproduct: false,
    };
  },
  props: {
    form: Object
  },
  methods: {
    /*关闭弹窗*/
    /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.isproduct = false;
      console.log("e",e)
      if (e.type == 'success') {
        var clerk = {
          real_name:e.params[0].real_name,
          clerk_id:e.params[0].clerk_id,
        }
        self.form.model.clerk = clerk
        self.form.model.clerk_id = clerk.clerk_id
      }
    },
    /*打开添加*/
    changeProduct() {
      
      this.isproduct = true;
    },
    /*删除标签*/
    deleteClick() {
      let self = this;
       self.form.model.clerk = ''
        self.form.model.clerk_id = 0
    },
  }
};
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>./Clerk.vue



// WEBPACK FOOTER //
// src/views/product/product/part/Clerk.vue